export function pick(obj, ...keys) {
    const picked = {};
    // eslint-disable-next-line security/detect-object-injection
    for (const key of keys)
        if (key in obj)
            picked[key] = obj[key];
    return picked;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGljay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9waWNrLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sVUFBVSxJQUFJLENBQ25CLEdBQU0sRUFDTixHQUFHLElBQU87SUFFVixNQUFNLE1BQU0sR0FBZSxFQUFFLENBQUE7SUFDN0IsNERBQTREO0lBQzVELEtBQUssTUFBTSxHQUFHLElBQUksSUFBSTtRQUFFLElBQUksR0FBRyxJQUFJLEdBQUc7WUFBRSxNQUFNLENBQUMsR0FBRyxDQUFDLEdBQUcsR0FBRyxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQzlELE9BQU8sTUFBNEIsQ0FBQTtBQUNwQyxDQUFDIn0=